import { Link } from "react-router-dom";
import { FormGroup, Input, Label } from "reactstrap";
import { Btn, H6, Image } from "../../../../../AbstractElements";
import { ManageOrderData } from "../../../../../Data/General/Dashboard/ECommerce";
import { dynamicImage } from "../../../../../Utils";

export const ManageOrderTableBody = () => {
  return (
    <tbody>
      {ManageOrderData.map((item, index) => (
        <tr key={index}>
          <td>
            <FormGroup check>
              <Input type="checkbox" />
              <Label check />
            </FormGroup>
          </td>
          <td>
            <div className="d-flex gap-2">
              <Image src={dynamicImage(item.image)} alt="user" />
              <Link to={`${process.env.PUBLIC_URL}/applications/email/letter_box`}>
                <H6>{item.name}</H6>
              </Link>
            </div>
          </td>
          <td>{item.id}</td>
          <td>{item.date}</td>
          <td>{item.price}</td>
          <td>
            <Btn color={item.color}>{item.status}</Btn>
          </td>
          <td>{item.quantity}</td>
        </tr>
      ))}
    </tbody>
  );
};
